// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3Ev0n","footer":"ReportModalFilter_footer__qB9hg"};